import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider } from './components/intranet/store';
import { Layout } from './components/intranet/Layout';
import { HomePage } from './components/intranet/pages/HomePage';
import { NewsPage } from './components/intranet/pages/NewsPage';
import { ArticlePage } from './components/intranet/pages/ArticlePage';
import { FeedPage } from './components/intranet/pages/FeedPage';
import { PostPage } from './components/intranet/pages/PostPage';
import { PeoplePage } from './components/intranet/pages/PeoplePage';
import { ProfilePage } from './components/intranet/pages/ProfilePage';
import { TeamsPage } from './components/intranet/pages/TeamsPage';
import { TeamDetailPage } from './components/intranet/pages/TeamDetailPage';
import { EventsPage } from './components/intranet/pages/EventsPage';
import { AppsPage } from './components/intranet/pages/AppsPage';
import { LibraryPage } from './components/intranet/pages/LibraryPage';
import { RecognitionPage } from './components/intranet/pages/RecognitionPage';
import { SettingsPage } from './components/intranet/pages/SettingsPage';
import { AdminGate } from './components/intranet/pages/AdminGate';
import { NotFoundPage } from './components/intranet/pages/NotFoundPage';
export function App() {
  return <AppProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <Routes data-id="element-2">
          <Route element={<Layout data-id="element-4" />} data-id="element-3">
            <Route index element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="news" element={<NewsPage data-id="element-8" />} data-id="element-7" />
            <Route path="news/:id" element={<ArticlePage data-id="element-10" />} data-id="element-9" />
            <Route path="feed" element={<FeedPage data-id="element-12" />} data-id="element-11" />
            <Route path="feed/:id" element={<PostPage data-id="element-14" />} data-id="element-13" />
            <Route path="people" element={<PeoplePage data-id="element-16" />} data-id="element-15" />
            <Route path="people/:id" element={<ProfilePage data-id="element-18" />} data-id="element-17" />
            <Route path="teams" element={<TeamsPage data-id="element-20" />} data-id="element-19" />
            <Route path="teams/:id" element={<TeamDetailPage data-id="element-22" />} data-id="element-21" />
            <Route path="events" element={<EventsPage data-id="element-24" />} data-id="element-23" />
            <Route path="apps" element={<AppsPage data-id="element-26" />} data-id="element-25" />
            <Route path="knowledge" element={<LibraryPage kind="knowledge" data-id="element-28" />} data-id="element-27" />
            <Route path="documents" element={<LibraryPage kind="documents" data-id="element-30" />} data-id="element-29" />
            <Route path="recognition" element={<RecognitionPage data-id="element-32" />} data-id="element-31" />
            <Route path="settings" element={<SettingsPage data-id="element-34" />} data-id="element-33" />
            <Route path="admin" element={<AdminGate data-id="element-36" />} data-id="element-35" />
            <Route path="*" element={<NotFoundPage data-id="element-38" />} data-id="element-37" />
          </Route>
        </Routes>
      </BrowserRouter>
    </AppProvider>;
}